import React, {useEffect} from 'react';
import Header from "../components/Header";
import CustomeNavbar from "../components/CustomeNavbar";
import ToTop from "../components/ToTop";
import Footer from "../components/Footer";
import VisiMisiContent from "../contents/VisiMisiContent";

const VisiMisi = () => {
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    useEffect(() => {
        scrollToTop();
    }, []);
    return (
        <div>
            <Header/>
            <CustomeNavbar/>
            <VisiMisiContent />
            <ToTop/>
            <Footer/>
        </div>
    );
};

export default VisiMisi;